__turbopack_context__.v({
  "group": "cbLvuG_group",
  "indicator": "cbLvuG_indicator",
  "item": "cbLvuG_item",
});
